import type { AdminAiFeaturesModuleCardProps } from "../../models/admin-ai-features.models";
import { adminAiScansStyles } from "../../styles/admin-ai-scans.styles";
import { getAiFeaturesCountItems } from "../../utils/admin-ai-features.utils";
import AdminAiFeaturesTreeNode from "./AdminAiFeaturesTreeNode";
import AdminAiScanJsonDetails from "./AdminAiScanJsonDetails";
import AdminAiScanTreeSummary from "./AdminAiScanTreeSummary";
import { useState } from "react";

// Keep a module's metadata and untouched JSON next to its readable inventory, so annotations remain inspectable.
const AdminAiFeaturesModuleCard = ({ module, expansion }: AdminAiFeaturesModuleCardProps) => {
  const [open, setOpen] = useState(expansion !== "collapsed");
  const generatedAt = module.metadata.generatedAt;
  const confidence = module.metadata.scannerConfidence;

  return (
    <article data-test={`admin-ai-features-module-${module.moduleId}`} className={adminAiScansStyles.reportCard}>
      <details open={open} onToggle={(event) => setOpen(event.currentTarget.open)}>
        <AdminAiScanTreeSummary
          label={module.moduleName}
          id={module.moduleId}
          counts={getAiFeaturesCountItems(module.counts)}
        />
        {open && (
          <div>
            <div className={adminAiScansStyles.treeChildren}>
              {module.children.length ? (
                module.children.map((node) => (
                  <AdminAiFeaturesTreeNode key={node.id} node={node} expansion={expansion} />
                ))
              ) : (
                <p className="py-3 text-sm opacity-60">No business objects recorded.</p>
              )}
            </div>
            <div className="border-t border-slate-200 p-3 dark:border-gray-600">
              <details className="text-xs leading-6 text-slate-500 dark:text-gray-400">
                <summary className="cursor-pointer font-semibold">Report source and metadata</summary>
                <p>{module.title}</p>
                <p className="break-words font-mono">{module.file.path}</p>
                {typeof generatedAt === "string" && <p>Generated: {generatedAt}</p>}
                {typeof confidence === "string" && <p>Scanner confidence: {confidence}</p>}
              </details>
              <AdminAiScanJsonDetails value={module.file.report} label="Complete report JSON" />
            </div>
          </div>
        )}
      </details>
    </article>
  );
};

export default AdminAiFeaturesModuleCard;
